module.exports = __webpack_public_path__ + "static/img/91BM-069-JackZhang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-069-JackZhang.jpg
// module id = KBfr
// module chunks = 0